import index from '@/views/yiliaohuzhu/index'
import baseinfo from '@/views/yiliaohuzhu/baseinfo'
import baseinfo2 from '@/views/yiliaohuzhu/baseinfo2'
import workspace from '@/views/yiliaohuzhu/workspace'
import detail from '@/views/yiliaohuzhu/detail'
import down from '@/views/yiliaohuzhu/down'
import create1 from '@/views/yiliaohuzhu/createList1'
import create2 from '@/views/yiliaohuzhu/createList2'
import create from '@/views/yiliaohuzhu/create'
import home from '@/views/yiliaohuzhu/home'
import edit1 from '@/views/yiliaohuzhu/editList1'
import edit2 from '@/views/yiliaohuzhu/editList2'

export default [
  {
    path: '/yiliaohuzhu',
    name: 'yiliaohuzhu',
    meta: {
      title: '首页',
      NeedLogin: false,
      keepAlive: false
    },
    component: index
  }, {
    path: '/yiliaohuzhu/baseinfo/:id',
    name: 'yiliaohuzhuInfo',
    meta: {
      title: '用户',
      NeedLogin: false,
      keepAlive: false
    },
    component: baseinfo
  }, {
    path: '/yiliaohuzhu/workspace',
    name: 'yiliaohuzhuWorkspace',
    meta: {
      title: '管理员',
      NeedLogin: false,
      keepAlive: true
    },
    component: workspace
  }, {
    path: '/yiliaohuzhu/detail/:areaid/:type',
    name: 'yiliaohuzhuDetail',
    meta: {
      title: '审核',
      NeedLogin: false,
      keepAlive: false
    },
    component: detail
  }, {
    path: '/yiliaohuzhu/down/:areaid/:type',
    name: 'yiliaohuzhuDown',
    meta: {
      title: '查看审核',
      NeedLogin: false,
      keepAlive: false
    },
    component: down
  }, {
    path: '/yiliaohuzhu/createmajor',
    name: 'yiliaohuzhuCreate1',
    meta: {
      title: '新增重大病补助申请',
      NeedLogin: false,
      keepAlive: false
    },
    component: create1
  }, {
    path: '/yiliaohuzhu/createhospital',
    name: 'yiliaohuzhuCreate2',
    meta: {
      title: '新增住院补助申请',
      NeedLogin: false,
      keepAlive: false
    },
    component: create2
  }, {
    path: '/yiliaohuzhu/create',
    name: 'yiliaohuzhuCreate',
    meta: {
      title: '新增',
      NeedLogin: false,
      keepAlive: false
    },
    component: create
  }, {
    path: '/yiliaohuzhu/home',
    name: 'yiliaohuzhuHome',
    meta: {
      title: '首页', // 医疗互助新页面：新增
      NeedLogin: false,
      keepAlive: false
    },
    component: home
  }, {
    path: '/yiliaohuzhu/editmajor/:id',
    name: 'yiliaohuzhuEdit1',
    meta: {
      title: '修改重大病补助申请',
      NeedLogin: false,
      keepAlive: false
    },
    component: edit1
  }, {
    path: '/yiliaohuzhu/edithospital/:id',
    name: 'yiliaohuzhuEdit2',
    meta: {
      title: '修改住院补助申请',
      NeedLogin: false,
      keepAlive: false
    },
    component: edit2
  }, {
    path: '/yiliaohuzhu/baseinfo2/:id',
    name: 'yiliaohuzhuInfo2',
    meta: {
      title: '用户',
      NeedLogin: false,
      keepAlive: false
    },
    component: baseinfo2
  }
]
